var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ButtonTemplate',{attrs:{"on-click":_vm.onClick,"title":"Insert Bubbles Legends"}},[_c('b-icon',{attrs:{"icon":"card-list"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }